import React from "react";

import "react-dates/lib/css/_datepicker.css";
import { SingleDatePicker } from "react-dates";

import { compose, withState } from "recompose";

import styled from "react-emotion";
import { fontSize, fontWeight, space } from "styled-system";

import { Box } from "src/components";
import { colors, fonts } from "src/styles";

import FloatingLabel from "./FloatingLabel";
import { isBefore, isAfter } from "date-fns";

const InputWrapper = styled.div`
  .SingleDatePicker_picker {
    font-family: ${fonts.sansSerif};
    .CalendarDay {
      font-family: ${fonts.numeric};
    }
    .CalendarDay__selected {
      background: ${colors.green};
      border-color: ${colors.green};
    }
  }
  .SingleDatePicker,
  .SingleDatePickerInput,
  .DateInput,
  .DateInput_input {
    background: none;
  }
  .DateInput_input {
    border-bottom: 0;
    font-family: ${props => (props.numeric ? fonts.numeric : fonts.sansSerif)};
    font-weight: ${props => (props.numeric ? "300" : "400")};

    ${space};
    ${fontSize};
    ${fontWeight};
  }
  .DateInput_input::placeholder {
    color: ${colors.placeholder};
  }
`;

const checkBlockedDay = ({ minimumDate, maximumDate }) => date => {
  return (
    (minimumDate && isBefore(date, minimumDate)) ||
    (maximumDate && isAfter(date, maximumDate))
  );
};

const DateInput = ({
  value,
  setValue,
  focused,
  setFocused,
  id = "date-input",
  label,
  placeholder,
  minimumDate,
  maximumDate,
  ...props
}) => {
  const floating = Boolean(value && label);
  const isDayBlocked = checkBlockedDay({ minimumDate, maximumDate });

  return (
    <Box
      borderRadius={5}
      borderWidth={1}
      borderColor="divider"
      bg="white"
      mb={2}
      style={{ position: "relative" }}
    >
      <InputWrapper
        pb={floating ? "8px" : 2}
        pt={floating ? "24px" : 2}
        pr={3}
        pl={3}
        fontSize={3}
        numeric={Boolean(value)}
      >
        <SingleDatePicker
          block={true}
          noBorder={true}
          date={value} // momentPropTypes.momentObj or null
          onDateChange={setValue} // PropTypes.func.isRequired
          focused={focused} // PropTypes.bool
          onFocusChange={({ focused }) => setFocused(focused)} // PropTypes.func.isRequired
          id={id} // PropTypes.string.isRequired,
          displayFormat="MMMM Do, YYYY"
          hideKeyboardShortcutsPanel={true}
          placeholder={placeholder || label}
          isDayBlocked={isDayBlocked}
          isOutsideRange={isDayBlocked}
        />
      </InputWrapper>
      {floating && <FloatingLabel>{label}</FloatingLabel>}
    </Box>
  );
};

const enhance = compose(withState("focused", "setFocused", false));

export default enhance(DateInput);



// WEBPACK FOOTER //
// ./src/components/Form/DateInput.js